   <img [src]="image" width= "300px" @tooltip>




 